import React from 'react';
import axios from 'axios';
import { Header, Tab, Segment } from 'semantic-ui-react';
import { fetchCurrentAcademicYear, fetchMarks, fetchAcademicYears } from '../../Lookups/util';
import ExamApplicationsCurrentYear from './ExamApplicationsCurrentYear';
import ExamApplicationsPreviousYears from './ExamApplicationsPreviousYears';
import ExamApplicationsByProfessor from './ExamApplicationsByProfessor';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const fetchGroupTypes = () => axios.get('/group-types');

export default class ExamAplications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAcademicYear: '',
            academicYears: [],
            marks: [],
            groupTypeId: '',
        };
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');

        let activeRole = localStorage.getItem('activeRole')
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole)

        axios.all([fetchCurrentAcademicYear(), fetchMarks(), fetchAcademicYears(), fetchGroupTypes()])
            .then(axios.spread((currentAcademicYearRes, marksRes, academicYearsRes, groupRes) => {
                const academicYears = academicYearsRes.data.map(el => ({
                    ...el, text: el.name, key: el.id, value: el.id
                })).reverse();

                this.setState({
                    marks: marksRes.data,
                    currentAcademicYear: currentAcademicYearRes.data.id,
                    academicYears,
                    groupTypeId: groupRes.data.find(el => el._key === 'exam').id
                });
            }))
            .catch(err => {
                console.log('Failed to fetch current academic year or academic years or marks');
            });
    }


    render() {
        const panes = [
            {
                menuItem: 'Prijave po profesoru',
                render: () => (<Tab.Pane>
                    <div><br/>
                        <ExamApplicationsByProfessor
                            academicYears={this.state.academicYears}
                        />
                    </div>
                </Tab.Pane>)
            },
            {
                menuItem: 'Prijave za trenutnu akademsku godinu',
                render: () => (<Tab.Pane><div><br/>
                    <ExamApplicationsCurrentYear
                        currentAcademicYear={this.state.currentAcademicYear}
                        marks={this.state.marks}
                        groupTypeId={this.state.groupTypeId}
                        currentYear
                    /></div></Tab.Pane>)
            },
            {
                menuItem: 'Prijave za prethodne akademske godine',
                render: () => (<Tab.Pane><div><br/>
                    <ExamApplicationsPreviousYears
                        academicYears={this.state.academicYears.filter(el => el.id < this.state.currentAcademicYear)}
                        marks={this.state.marks}
                        groupTypeId={this.state.groupTypeId}
                        previousYears
                    /></div></Tab.Pane>)
            }
        ];

        return (
            <div>

                <Header as="h1">Prijave za polaganje ispita</Header>
                <Segment.Group raised>
                    <Segment><h3>Odabir predmeta i ispita</h3></Segment>
                    <Segment><Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} /></Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamApplications/ExamApplications.js